import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _, { chain, partial, split } from 'lodash';

import {
    PENDING,
    VALIDATED,
    CANCELED,
    INSUFFICIENT_FOUND,
    WAITING_TRANSACTION
} from '../../../../services/checkout/constants';
import { PATH } from '../../../../constants/path';
import { COOKIE_KEY_EMAIL } from '../../../../constants/cookie';
import { MODAL_TYPE_KYC } from '../../../../services/modal/constants';
import { APPLICATION_ID, APP_NAME, REDIRECT_URL } from '../../../../constants';
import { KYC_USE_CASE_WAITING_TRANSACTION } from '../../../../services/kyc/constants';

import { showModal } from '../../../../services/modal/actions';
import { fetchCheckoutDetails } from '../../../../services/checkout/actions';
import { fetchEbonOrderByIdWithCode } from '../../../../services/ebon/actions';

import { getI18nByApp } from '../../../../services/i18n/selector';
import { getPartner } from '../../../../services/partner/selector';

import { useTracking } from '../../../../tracking/provider';

import Stepper from '../Stepper';
import { Logo } from '../../../icons/Logo';
import HeadComponent from '../../../HeadComponent';
import LocalizedNavLink from '../../../router/LocalizedNavLink';
import { LoadingComponent } from '../../../loading/LoadingComponent';
import ConfirmationEbonPageKycBloc from './kyc/ConfirmationEbonPageKycBloc';
import ConfirmationEbonPageMessageBloc from './message/ConfirmationEbonPageMessageBloc';

import { Template } from '../../../template/TemplateStyle';
import { HeaderNav } from '../../../header/HeaderNavComponentStyle';
import { ConfirmationEbonPageContainer } from './ConfirmationEbonPageStyle';
import { Header, HeaderGlobalStyle } from '../../../header/HeaderComponentStyle';

const COFIDIS_ID = '111';
const LYZI_ID = '147';

const getEbonOrderState = state => {
    if (APPLICATION_ID === LYZI_ID || APPLICATION_ID === COFIDIS_ID) return VALIDATED;
    return state.checkout.details ? state.checkout.details.ebonOrderState : null;
};

const ConfirmationEbonPage = ({
    i18n,
    history,
    fetchEbonOrderByIdWithCode,
    fetchCheckoutDetails,
    orderId,
    fetchOrder,
    partnerId,
    partnerName,
    confirmedOrder,
    checkoutSessionId,
    ebonOrderState,
    fetchingDetails,
    showModal
}) => {
    const [kyc, setKyc] = useState(false);
    const [kycValidated, setKycValidated] = useState(false);
    const [pendingInterval, setPendingInterval] = useState(null);
    const [detailsInterval, setDetailsInterval] = useState(null);

    const { gtm, ready } = useTracking();

    const sessionEmail = sessionStorage.getItem(COOKIE_KEY_EMAIL) || '';

    const loading =
        APPLICATION_ID !== COFIDIS_ID &&
        APPLICATION_ID !== LYZI_ID &&
        (fetchOrder || fetchingDetails || !ebonOrderState || ebonOrderState === PENDING);

    useEffect(() => {
        fetchEbonOrderByIdWithCode(orderId);
    }, []);

    /* Get checkout order details */
    useEffect(() => {
        if (checkoutSessionId) {
            fetchCheckoutDetails(orderId);
        }
    }, [checkoutSessionId]);

    /* Handle order states */
    useEffect(() => {
        if (!ebonOrderState || ebonOrderState === PENDING) {
            if (!pendingInterval) {
                setPendingInterval(
                    setInterval(() => {
                        fetchCheckoutDetails(orderId);
                    }, 5000)
                );
                return () => {
                    clearInterval(pendingInterval);
                };
            }
        }

        if (!kycValidated && ebonOrderState && ebonOrderState === WAITING_TRANSACTION) {
            clearInterval(pendingInterval);
            clearInterval(detailsInterval);
            setKyc(true);
            showModal(MODAL_TYPE_KYC, {
                hideCloseButton: true,
                useCase: KYC_USE_CASE_WAITING_TRANSACTION
            });
        }

        if (ebonOrderState === CANCELED || ebonOrderState === INSUFFICIENT_FOUND) {
            clearInterval(pendingInterval);
            clearInterval(detailsInterval);
            history.push(`${PATH.EBON_ERROR_PATH}-${partnerId}?paiement=error&orderId=${orderId}`);
        }

        if (ebonOrderState === VALIDATED) {
            ready &&
                gtm.event('purchase', {
                    partner: { name: partnerName, id: partnerId },
                    orderId,
                    email: sessionEmail
                });
            clearInterval(pendingInterval);
            clearInterval(detailsInterval);

            if (REDIRECT_URL) {
                if (APPLICATION_ID === '142') {
                    setTimeout(() => {
                        window.location.href = REDIRECT_URL;
                    }, 10000);
                } else {
                    window.location.href = REDIRECT_URL;
                }
            }
        }
    }, [ebonOrderState]);

    return (
        <Template className="flex-container-v">
            <HeaderNav className="entete minimal" id="entete">
                <div className="flex-container-v">
                    <Header className="tetedepage conteneur flex-container-h flex-center-alt">
                        <HeaderGlobalStyle />
                        <LocalizedNavLink to={PATH.HOME_PATH} title={APP_NAME} className="logo">
                            <Logo />
                        </LocalizedNavLink>
                        <Stepper steps={getI18nByApp(i18n, 'page.EBON.STEPS')} current={4} />
                    </Header>
                </div>
            </HeaderNav>
            <ConfirmationEbonPageContainer className="conteneur conteneur-mobile">
                <HeadComponent
                    title={getI18nByApp(i18n, 'page.EBON.CONFIRMATION.TITLE')}
                    description={getI18nByApp(i18n, 'page.EBON.DESCRIPTION')}
                />
                <Stepper
                    steps={getI18nByApp(i18n, 'page.EBON.STEPS')}
                    current={4}
                    cssClass="mobileDisplay"
                />

                <div className="congratulation-container">
                    {loading && !kycValidated && <LoadingComponent />}

                    <ConfirmationEbonPageKycBloc
                        orderId={orderId}
                        fetchOrder={fetchOrder}
                        ebonOrderState={ebonOrderState}
                        kyc={kyc}
                        setKyc={setKyc}
                        kycValidated={kycValidated}
                        setKycValidated={setKycValidated}
                        detailsInterval={detailsInterval}
                        setDetailsInterval={setDetailsInterval}
                    />

                    {!kyc && !loading && ebonOrderState && ebonOrderState === VALIDATED && (
                        <ConfirmationEbonPageMessageBloc
                            partnerId={partnerId}
                            partnerName={partnerName}
                            sessionEmail={sessionEmail}
                            confirmedOrder={confirmedOrder}
                            ebonOrderState={ebonOrderState}
                        />
                    )}
                </div>
            </ConfirmationEbonPageContainer>
        </Template>
    );
};

const mapStateToProps = (state, ownProps) => {
    const search = ownProps.location.search;
    const params =
        search &&
        chain(search)
            .replace('?', '') // a=toto
            .split('&') // ["a=toto","c=bobo","f=coco"]
            .map(partial(split, _, '=', 2)) // [["a","toto"],["c","bobo"],["f","coco"]]
            .fromPairs() // {"a":"toto","c":"bobo","f":"coco"}
            .value();
    const orderId = params.orderId;

    const confirmedOrder = state.ebon.confirmedOrder;
    const partner = getPartner(state, confirmedOrder.partnerId);
    const partnerId = partner && partner.id;
    const partnerName = partner && partner.name;

    return {
        i18n: state.i18n,
        user: state.account.user,
        confirmedOrder,
        fetchOrder: state.ebon.fetchOrder,
        orderId,
        partnerName,
        partnerId,
        checkoutSessionId: params['cko-session-id'],
        ebonOrderState: getEbonOrderState(state),
        fetchingDetails: state.checkout.fetchingDetails
    };
};

const mapDispatchToProps = {
    fetchEbonOrderByIdWithCode,
    fetchCheckoutDetails,
    showModal
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConfirmationEbonPage));



// WEBPACK FOOTER //
// ./src/components/pages/ebon/confirmation/ConfirmationEbonPage.js